import PropTypes from 'prop-types';
import React, { Component } from 'react';
import numeral from 'numeral';
import VideoSeekBar from './VideoSeekBar';
import Icon from '../icons/Icon';

export default class VideoControls extends Component {
  static propTypes = {
    buffered: PropTypes.number.isRequired,
    currentTime: PropTypes.number.isRequired,
    duration: PropTypes.number.isRequired,
    paused: PropTypes.bool.isRequired,
    muted: PropTypes.bool.isRequired,
    setCurrentTime: PropTypes.func.isRequired,
    setVolume: PropTypes.func.isRequired,
    fullscreen: PropTypes.bool,
    title: PropTypes.string,
    toggleMute: PropTypes.func.isRequired,
    toggleFullscreen: PropTypes.func.isRequired,
    togglePlayPause: PropTypes.func.isRequired,
    volume: PropTypes.number.isRequired,
  };

  render() {
    const {
      buffered,
      currentTime,
      duration,
      paused,
      muted,
      setCurrentTime,
      setVolume,
      title,
      toggleMute,
      toggleFullscreen,
      togglePlayPause,
      volume,
    } = this.props;

    return (
      <div className="video-player__video-controls__wrapper" style={paused ? { opacity: '1' } : null}>
        <VideoSeekBar
          duration={duration}
          buffered={buffered}
          played={currentTime}
          paused={paused}
          onCurrentTimeChange={setCurrentTime}
        />
        <div className="video-player__control-bar">
          <div className="video-controls__current-time">
            {numeral(currentTime).format('00:00:00')}/{numeral(duration).format('00:00:00')}
          </div>
          <div className="video-controls">
            <div className="video-controls__left-controls">
              <button type="button" className="button button--theme--plain" onClick={togglePlayPause}>
                {paused ? <Icon icon="Play" /> : <Icon icon="Pause" />}
              </button>
              <button type="button" className="button button--theme--plain" onClick={toggleMute}>
                {muted || volume === 0 ? <Icon icon="Mute" /> : <Icon icon="Sound" />}
              </button>
              <input
                type="range"
                value={muted ? 0 : volume}
                max={1}
                min={0}
                step={0.05}
                onMouseDown={event => (muted ? toggleMute() : false)}
                onChange={event => setVolume(event.target.value)}
              />
            </div>
            <div className="video-controls__video-title">{title}</div>
            <button type="button" className="button button--theme--plain" onClick={toggleFullscreen}>
              <Icon icon={this.props.fullscreen ? 'Minimize' : 'Fullscreen'} />
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/video/VideoControls.js